<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
  <path
      d="M6.0625 14.7116L5.28848 13.9376L9.22598 10.0001L5.28848 6.0626L6.0625 5.28857L10 9.22607L13.9375 5.28857L14.7115 6.0626L10.774 10.0001L14.7115 13.9376L13.9375 14.7116L10 10.7741L6.0625 14.7116Z"
      />
</svg>
</template>